import React from 'react'

import { formatColorProps } from '../helpers/colors'
import { random } from '../helpers/array'
import { useTheme } from '../../components/theme/ThemeHandler'
import { useTinyColor } from '../../components/theme/_hooks/colors'

const PATTERNS = [
  'diagonal', //
  'lines',
  'paper',
  'zigzag',
  'zigzag3d',
  'isometric',
  'rhombus',
  'retangles'
]

export const useBgPatternsStyle = props => {
  const theme = useTheme()
  let { bgColor, pattern } = formatColorProps(props, theme)

  const tColor = useTinyColor(bgColor)
  const color1 = tColor.toHexString()
  const color2 = tColor.lighten(3).toHexString()

  return React.useMemo(() => {
    pattern = pattern === 'random' ? random(PATTERNS) : pattern

    switch (pattern) {
      case 'diagonal':
        return `
					background-color: ${color1};
					opacity: 0.8;
					background: repeating-linear-gradient(45deg, ${color1}, ${color1} 5px, ${color2} 5px, ${color2} 25px);
			`

      case 'triangles':
        return `
					background-color: ${color1};
					opacity: 0.8;
					background-image: linear-gradient(45deg, ${color2} 50%, ${color1} 50%);
					background-size: 10px 10px;
				`

      case 'lines':
        return `
					background-color: ${color1};
					opacity: 0.8;
					background-image: linear-gradient(0deg, ${color1} 50%, ${color2} 50%);
					background-size: 10px 10px;
				`

      case 'paper':
        return `
					background-color: ${color1};
					opacity: 0.8;
					background-image:  linear-gradient(${color2} 2px, transparent 2px), linear-gradient(90deg, ${color2} 2px, transparent 2px), linear-gradient(${color2} 1px, transparent 1px), linear-gradient(90deg, ${color2} 1px, ${color1} 1px);
					background-size: 50px 50px, 50px 50px, 10px 10px, 10px 10px;
					background-position: -2px -2px, -2px -2px, -1px -1px, -1px -1px;
				`

      case 'isometric':
        return `
					background-color: ${color1};
					opacity: 0.8;
					background-image:  linear-gradient(30deg, ${color2} 12%, transparent 12.5%, transparent 87%, ${color2} 87.5%, ${color2}), linear-gradient(150deg, ${color2} 12%, transparent 12.5%, transparent 87%, ${color2} 87.5%, ${color2}), linear-gradient(30deg, ${color2} 12%, transparent 12.5%, transparent 87%, ${color2} 87.5%, ${color2}), linear-gradient(150deg, ${color2} 12%, transparent 12.5%, transparent 87%, ${color2} 87.5%, ${color2}), linear-gradient(60deg, ${color2}77 25%, transparent 25.5%, transparent 75%, ${color2}77 75%, ${color2}77), linear-gradient(60deg, ${color2}77 25%, transparent 25.5%, transparent 75%, ${color2}77 75%, ${color2}77);
					background-size: 20px 35px;
					background-position: 0 0, 0 0, 10px 18px, 10px 18px, 0 0, 10px 18px;
				`

      case 'zigzag3d':
        return `
					background-color: ${color1};
					opacity: 0.8;
					background: linear-gradient(135deg, ${color2}55 25%, transparent 25%) -10px 0/ 20px 20px, linear-gradient(225deg, ${color2} 25%, transparent 25%) -10px 0/ 20px 20px, linear-gradient(315deg, ${color2}55 25%, transparent 25%) 0px 0/ 20px 20px, linear-gradient(45deg, ${color2} 25%, ${color1} 25%) 0px 0/ 20px 20px;
				`

      case 'retangles':
        return `
					background-color: ${color1};
					opacity: 0.8;
					background-image:  repeating-linear-gradient(45deg, ${color2} 25%, transparent 25%, transparent 75%, ${color2} 75%, ${color2}), repeating-linear-gradient(45deg, ${color2} 25%, ${color1} 25%, ${color1} 75%, ${color2} 75%, ${color2});
					background-position: 0 0, 10px 10px;
					background-size: 20px 20px;
				`

      case 'rhombus':
        return `
					background-color: ${color1};
					opacity: 0.8;
					background-image:  linear-gradient(135deg, ${color2} 25%, transparent 25%), linear-gradient(225deg, ${color2} 25%, transparent 25%), linear-gradient(45deg, ${color2} 25%, transparent 25%), linear-gradient(315deg, ${color2} 25%, ${color1} 25%);
					background-position:  10px 0, 10px 0, 0 0, 0 0;
					background-size: 10px 10px;
					background-repeat: repeat;
				`

      case 'zigzag':
        return `
					background-color: ${color1};
					opacity: 0.8;
					background-image:  linear-gradient(135deg, ${color2} 25%, transparent 25%), linear-gradient(225deg, ${color2} 25%, transparent 25%), linear-gradient(45deg, ${color2} 25%, transparent 25%), linear-gradient(315deg, ${color2} 25%, ${color1} 25%);
					background-position:  10px 0, 10px 0, 0 0, 0 0;
					background-size: 20px 20px;
					background-repeat: repeat;
				`

      default:
        return ''
    }
  }, [color1, color2, pattern])
}
